import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FindCard extends Bloc {

	constructor (src, ctx) {

		super("findcard", src, ctx);
		this.f = (src, ins) => {
			var items = ins[0].cards.filter(card => !ins[1] || ins[1](card));
			var item = items.length > 0 ? items[Math.floor(Math.random()*items.length)] : null;
			return [item, item !== null];
		};
		this.types = [Types.location, Types.cardfilter];
	}
}